import { FieldPath, FieldValues, UseControllerProps, useController } from 'react-hook-form';
import * as RadioGroup from '@givebutter/primitives/radio-group';
import type { IRadioGroupProps } from '@givebutter/primitives/radio-group';

interface UseFormRadioGroupProps<T extends FieldValues, K extends FieldPath<T>>
    extends UseControllerProps<T, K>,
        Omit<IRadioGroupProps, 'defaultValue' | 'name' | 'onChange'> {
    onChange?: (value: string) => void;
}

const UseFormRadioGroup = <T extends FieldValues, K extends FieldPath<T>>({
    control,
    name,
    onValueChange: onValueChangeConsumer,
    onChange: onChangeConsumer,
    defaultValue,
    rules,
    ...props
}: UseFormRadioGroupProps<T, K>) => {
    const {
        field: { onChange: onChangeInternal, value, name: nameInternal },
    } = useController({
        name,
        control,
        defaultValue,
        rules,
    });

    const onChange = (value: string) => {
        onChangeInternal(value);
        onValueChangeConsumer?.(value);
        onChangeConsumer?.(value);
    };

    return (
        <RadioGroup.Root
            {...props}
            name={nameInternal}
            value={value as string}
            onValueChange={onChange}
            defaultValue={value as string}
        />
    );
};

export { UseFormRadioGroup };
export type { UseFormRadioGroupProps };
